<template>
    <div class="business-tax-quick-declared-table">
        <el-table
            :data="data"
            ref="table"
            empty-text="無資料"
            class="tax-data-table invoice"
            v-loading="isLoading"
            :default-sort="{ prop: 'foO_DAT', order: 'ascending' }"
            :height="tableHeight"
            :key="tableKey"
            @select="onSelect"
            @select-all="onSelectAll"
            @sort-change="onSortChange"
        >
            <el-table-column width="20"> </el-table-column>
            <el-table-column label="類型" width="60">
                <template slot-scope="scope">
                    <span>{{ getTypeText(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="declareStatus" label="申報狀態" width="100">
                <template slot-scope="scope">
                    <div>
                        <span class="status-label declared">已申報</span>
                        <span v-if="!isQR()" class="edit-btn" @click="onOpenUpdateStatusDialog(scope.row)">
                            <i class="el-icon-edit-outline" />
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="type" label="單據類型" width="110" sortable>
                <template slot-scope="scope">
                    <span>{{ getReceiptTypeText(scope.row) }}</span>
                    <el-tooltip v-if="!onCheckType(scope.row)" effect="dark" placement="top" content="單據類型選擇錯誤">
                        <span class="icon el-icon-warning" style="display: inline-block; color: #ffba00; margin-left: 5px"></span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="foO_DAT" label="發票日期" width="105" sortable>
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column key="foo" prop="foo" label="發票號碼" width="150" sortable>
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.foO_DIS_CNL" class="cnl-label">作廢</span>
                        <ahReceiptNumber :v="scope.row.foo" />
                    </div>
                    <div v-if="checkNumberDuplicate(scope.row)" class="duplicate-item">重複</div>
                </template>
            </el-table-column>
            <el-table-column key="code" prop="code" width="85">
                <template slot="header">格式代號</template>
                <template v-if="scope.row.typ !== 1" slot-scope="scope">
                    <div>
                        {{ scope.row.code || "--" }}
                        <span v-if="isNormalDataRow(scope.row) && !isQR()" class="edit-btn" @click="onOpenUpdateCodeDialog(scope.row)">
                            <i class="el-icon-edit-outline" />
                        </span>

                        <el-tooltip v-if="isNormalDataRow(scope.row) && onCheckCode(scope.row)" effect="dark" placement="top" :content="onCheckCode(scope.row)">
                            <span class="icon el-icon-warning" style="display: inline-block; color: #ffba00; margin-left: 5px"></span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column key="nonTaxAmt" prop="nonTaxAmt" label="銷售額(未稅)" align="right" width="120" sortable>
                <template slot-scope="scope">
                    <Money v-if="scope.row.ioo || scope.row.tioo" :v="scope.row.amt - scope.row.amT_TAX" /> <!-- 發票 -->
                    <Money v-else-if="scope.row.payoo" :v="scope.row.amt - scope.row.tax" /> <!-- 請款單 -->
                    <Money v-else :v="scope.row.amt - scope.row.tax" /> <!-- 外部進項發票 -->
                </template>
            </el-table-column>
            <el-table-column key="tax" prop="tax" label="稅額" align="right" width="100" sortable>
                <template slot-scope="scope">
                    <Money v-if="scope.row.ioo || scope.row.tioo" :v="scope.row.amT_TAX" /> <!-- 發票 -->
                    <Money v-else-if="scope.row.payoo" :v="scope.row.tax" /> <!-- 請款單 -->
                    <Money v-else :v="scope.row.tax" /> <!-- 外部進項發票 -->
                </template>
            </el-table-column>
            <el-table-column key="amt" prop="amt" label="含稅金額" align="right" width="120" sortable>
                <template slot-scope="scope">
                    <Money :v="scope.row.amt" />
                </template>
            </el-table-column>
            <el-table-column key="companyName" prop="companyName" label="買方公司" min-width="115" :show-overflow-tooltip="true" sortable>
                <template slot-scope="scope">
                    {{ scope.row.ioo || scope.row.tioo ? scope.row.companyName : companyInfo.cH_CMP }}
                </template>
            </el-table-column>
            <el-table-column key="bsn" prop="bsn" label="買方統編" width="110" sortable>
                <template slot-scope="scope">
                    {{ scope.row.ioo || scope.row.tioo ? scope.row.bsn : companyInfo.bsn }}
                </template>
            </el-table-column>
            <el-table-column key="paymentCompanyName" prop="companyName" label="賣方公司" min-width="115" :show-overflow-tooltip="true" sortable>
                <template slot-scope="scope">
                    {{ scope.row.ioo || scope.row.tioo ? companyInfo.cH_CMP : scope.row.companyName }}
                </template>
            </el-table-column>
            <el-table-column key="paymentBsn" prop="bsn" label="賣方統編" width="110" sortable>
                <template slot-scope="scope">
                    {{ scope.row.ioo || scope.row.tioo ? companyInfo.bsn : scope.row.bsn }}
                </template>
            </el-table-column>
            <el-table-column v-if="isPaymentTab" key="sigN_STS" prop="sigN_STS" label="來源帳務狀態" width="130" sortable>
                <template slot-scope="scope">
                    <PaymentStatusLabel :statusNum="scope.row.sigN_STS" />
                </template>
            </el-table-column>
            <el-table-column key="ioo" prop="ioo" label="來源" width="115" sortable>
                <template slot-scope="scope">
                    <el-button v-if="!!scope.row.ioo" type="text" @click="$emit('open', scope.row.sno, 1)">
                        {{ scope.row.ioo }}
                    </el-button>
                    <el-button v-else-if="!!scope.row.tioo" type="text" @click="$emit('open', scope.row.tioo, 1, true)">
                        {{ scope.row.tioo }}
                    </el-button>
                    <el-button v-else-if="!!scope.row.payoo" type="text" @click="$emit('open', scope.row.paySno, 2)">
                        {{ scope.row.payoo }}
                    </el-button>
                    <div v-else>外部進項發票</div>
                </template>
            </el-table-column>
        </el-table>
        <UpdateStatusDialog :visible="UpdateStatusDialog.visible" :target="UpdateStatusDialog.target" @close="onUpdateStatusDialogClose" />
        <UpdateCodeDialog :visible="UpdateCodeDialog.visible" :target="UpdateCodeDialog.target" @close="onUpdateCodeDialogClose" />
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import {
    mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import { attachmentTypes } from '@/assets/commonData/options';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';
import UpdateStatusDialog from '@/components/dashboard/Accounting/BusinessTax/UpdateStatusDialog.vue';
import UpdateCodeDialog from '@/components/dashboard/Accounting/BusinessTax/UpdateCodeDialog.vue';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import { invoiceCodeOptions } from './CodeOptions';

export default {
    components: {
        ahReceiptNumber,
        UpdateCodeDialog,
        UpdateStatusDialog,
        PaymentStatusLabel,
    },
    props: {
        activeTab: {
            type: String,
            default: '',
        },
        paginationHeight: {
            type: Number,
            default: 50,
        },
    },
    data() {
        return {
            period: null,
            tableHeight: 0,
            tableKey: 1,

            declareUpdateObj: null,
            declareUpdateVisible: false,

            UpdateStatusDialog: {
                visible: false,
                target: null,
            },
            UpdateCodeDialog: {
                visible: false,
                target: null,
            },
        };
    },
    computed: {
        ...mapState({
            periodList: (state) => state.businessTax.periodList,
            isLoading: (state) => state.businessTax.isLoading,
            queryParams: (state) => state.businessTax.queryParams,
            selectedItems: (state) => state.businessTax.selectedItems,

            declaredInvoiceItems: (state) => state.businessTax.declaredInvoiceItems,
            declaredPaymentItems: (state) => state.businessTax.declaredPaymentItems,

            data: (state) => {
                let data;
                if (state.businessTax.declaredQueryParams.activeTab === 'Invoice') data = [...state.businessTax.declaredInvoiceItems];
                else if (state.businessTax.declaredQueryParams.activeTab === 'Payment') data = [...state.businessTax.declaredPaymentItems];
                else data = [...state.businessTax.declaredInvoiceItems, ...state.businessTax.declaredPaymentItems];

                // filter
                if (state.businessTax.declaredQueryParams.foo) data = data.filter((o) => o.foo.includes(state.businessTax.declaredQueryParams.foo));
                if (state.businessTax.declaredQueryParams.buyBsn) data = data.filter((o) => o.bsn.includes(state.businessTax.declaredQueryParams.buyBsn));
                if (state.businessTax.declaredQueryParams.saleBsn) data = data.filter((o) => o.bsn.includes(state.businessTax.declaredQueryParams.saleBsn));
                if (state.businessTax.declaredQueryParams.amt) data = data.filter((o) => o.amt === state.businessTax.declaredQueryParams.amt);

                return data;
            },
        }),
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),
        codeOptions() {
            return invoiceCodeOptions;
        },
        isPaymentTab() {
            return this.activeTab === 'Payment';
        },
    },
    methods: {
        ...mapMutations({
            setCurrentTableVueComponent: 'businessTax/setCurrentTableVueComponent',
            onSelect: 'businessTax/onSelect',
            onSelectAll: 'businessTax/onSelectAll',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
        }),
        isStatusChangeable(row) {
            return row.typ !== 1 && row.typ !== 4 && row.tax === 1;
        },
        resizeTableLayout() {
            const pageHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            const tableY = this.$refs.table.$el.getBoundingClientRect().top;
            const tableHeight = pageHeight - tableY - this.paginationHeight;
            this.tableHeight = tableHeight;
        },
        isExportable(row) {
            return !((row.typ === 3 && !row.bsn) || !row.foo || row.typ === 1);
        },

        // ======================== 新增Function =============================

        getDeclaredText(row) {
            if (this.isStatusChangeable(row)) {
                const value = row.typ < 0 ? row.foO_DIS_Declared : row.declared;
                return value ? '已申報' : '未申報';
            }

            if (row.tax === 2) return '零稅率';

            return '免申報';
        },

        // ======================== DataTableMixins =============================
        fetchSelection(sel) {
            sel.forEach((item) => {
                const SEL = _.find(this.data, (o) => o.sno === item.sno && o.typ === item.typ);
                if (SEL) {
                    this.$nextTick(() => {
                        this.$refs.table.toggleRowSelection(SEL);
                    });
                }
            });
        },
        onSortChange(event) {
            this.$emit('onSortChange', event);
        },
        checkNumberDuplicate(row) {
            if (!row.foo) return false;
            return _.find(this.data, (o) => o.sno !== row.sno && o.foo === row.foo);
        },
        getInvoiceTypeText(typ) {
            if (typ === -1) return '折讓';
            if (typ === 1) return 'INVOICE';
            if (typ === 2) return '二聯式發票';
            if (typ === 3) return '三聯式發票';
            if (typ === 4) return '核銷';
            return '';
        },
        getDiscountText(typ) {
            if (typ === 0) return '無折讓';
            if (typ === 1) return '部分折讓';
            if (typ === 2) return '全部折讓';
            return '';
        },
        isNormalDataRow(row) {
            return row.typ > 0 || !row.typ;
        },
        onCheckCode(item) {
            const validateCode = this.getValidateCode(item);
            if (validateCode) {
                // eslint-disable-next-line eqeqeq
                const validate = item.code == validateCode;
                return validate ? undefined : '與要求之格式代號不符，請確認發票日期、字軌號碼是否正確。';
            }

            return '本期查無對應發票字軌，請確認發票日期、字軌號碼是否正確。';
        },
        onCheckType(item) {
            const isIncome = item.ioo || item.tioo;
            if (isIncome) return true;

            // 格式代號和發票字軌不符時，不檢查格式代號與自選類型對應
            if (this.onCheckCode(item)) return true;

            const CODE = +item.code;
            if (isIncome) {
                switch (CODE) {
                case 31:
                case 35:
                    return item.typ === 3;
                case 32:
                    return item.typ === 2;
                default:
                    return false;
                }
            } else {
                switch (CODE) {
                case 21:
                    return item.filE_TYP === 3;
                case 22:
                    return item.filE_TYP === 11 || item.filE_TYP === 2;
                case 25:
                    return item.filE_TYP === 1 || item.filE_TYP === 10;
                default:
                    return false;
                }
            }
        },
        getTypeText(item) {
            if (item.ioo || item.tioo) return '銷項';
            return '進項';
        },
        getReceiptTypeText(item) {
            if (item.ioo || item.tioo) {
                return this.getInvoiceTypeText(item.typ);
            }
            return this.getPaymentAttachmentTextByKey(item.filE_TYP);
        },
        getPaymentAttachmentTextByKey(key) {
            return _.find(attachmentTypes, ['key', key])?.value;
        },
        getValidateCode(item) {
            if (item.typ < 0) return undefined;
            if (item.filE_TYP === 11) return 22;

            const isIncome = item.typ !== undefined;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) {
                return `${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`;
            }
            return undefined;
        },
        onOpenUpdateStatusDialog(datas) {
            this.UpdateStatusDialog.visible = true;
            this.UpdateStatusDialog.target = datas;
        },
        onUpdateStatusDialogClose() {
            this.UpdateStatusDialog.visible = false;
            this.UpdateStatusDialog.target = null;
        },
        onOpenUpdateCodeDialog(datas) {
            this.UpdateCodeDialog.visible = true;
            this.UpdateCodeDialog.target = datas;
        },
        onUpdateCodeDialogClose() {
            this.UpdateCodeDialog.visible = false;
            this.UpdateCodeDialog.target = null;
        },
    },
    mounted() {
        this.setCurrentTableVueComponent(this);

        const { table } = this.$refs;
        setTimeout(() => {
            this.tableKey += 1;
            table.key = this.tableKey;
            this.resizeTableLayout();
        }, 10);

        window.addEventListener('resize', this.resizeTableLayout);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeTableLayout);
    },
};
</script>

<style lang="scss">
@import "./common-style.scss";
.business-tax-quick-declared-table {
    .status-label.declared {
        color: #00b92b;
    }
    .edit-btn {
        color: #ccc;
        padding: 2px 3px;
        margin-left: 3px;

        &:hover {
            color: #888;
            cursor: pointer;
        }
    }
}
</style>
